import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs/operators';
import { ModalHostComponent } from './components/modal-host/modal-host.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SidebarComponent, CommonModule],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'MegaDev - Licencias';
  showSidebar = true;
  modalHostComponent = ModalHostComponent;

  constructor(private router: Router) {
    // Escuchar cambios de ruta para determinar si mostrar el sidebar
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // Ocultar sidebar solo en la página de login
        this.showSidebar = !event.url.includes('/login');
      });
  }
}
